import { renderToString } from 'preact-render-to-string';
import { MwlIcons } from "../components/MwlIcons";

import i18n from '@i18n';

export const initCloseButton = (lightbox) => {
  const closeIcon = <MwlIcons icon={'close'} />;

  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'custom-close',
      order: 20,
      ariaLabel: i18n.TOOLBAR.CLOSE,
      isButton: true,
      html: renderToString(closeIcon),
      onClick: () => {
        lightbox.pswp.close();
      },
      onInit: (el) => {
        el.dataset.tooltip = i18n.TOOLBAR.CLOSE;
      },
    });
  });
};
